(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hdb-reco-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hdb-reco-card')) {
    customElements.define('hdb-reco-card', class extends HTMLElement {
      connectedCallback() {
        if (this.recoReady) return;
        this.recoReady = true;
        const select = this.querySelector('[data-reco-select]');
        if (!select) return;
        const update = () => {
          const option = select.selectedOptions[0];
          const template = Array.from(this.querySelectorAll('template[data-reco-variant]')).find(item => item.dataset.recoVariant === select.value);
          if (!option || !template) return;
          this.querySelector('[data-reco-details]').replaceChildren(template.content.cloneNode(true));
          const button = this.querySelector('[data-reco-add]');
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
          this.querySelectorAll('[data-reco-link]').forEach(link => { link.href = option.dataset.url; });
          const image = this.querySelector('.hdb-reco__image img');
          if (image && option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
            image.alt = option.dataset.alt;
          }
        };
        select.addEventListener('change', update);
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
